import { IUpdateComponent, IComponent } from "../_types/interfaces";

const getAddress = async (): Promise<string> => {
    return new Promise<string>(resolve => setTimeout(() => resolve(
        "http://84.201.169.119:18080",
    ), 1000));
};

const getServices = async (uriService: string): Promise<Array<IComponent>> => {
    return new Promise<Array<IComponent>>(resolve => setTimeout(() => resolve([
        {name: 'Reader', version: "1.0.0.0"},
        {name: 'Web', version: "1.0.0.0"}
    ]), 1000));
};

const getPlugins = async (uriService: string): Promise<Array<IComponent>> => {
    return new Promise<Array<IComponent>>(resolve => setTimeout(() => resolve([
        {name: 'Plugin_R_LocalLoader', version: "1.0.0.0"},
        {name: 'Plugin_M_Packet70', version: "1.0.0.0"}
    ]), 1000));
};

const getInstallServices = async (): Promise<Array<IComponent>> => {
    return new Promise<Array<IComponent>>(resolve => setTimeout(() => resolve([
        {name: 'Reader', version: "1.0.0.0"}
    ]), 1000));
};

const getInstallPlugins = async (): Promise<Array<IComponent>> => {
    return new Promise<Array<IComponent>>(resolve => setTimeout(() => resolve([
        {name: 'Plugin_R_LocalLoader', version: "1.0.0.0"}
    ]), 1000));
};

const updateServices = async (services: Array<string>): Promise<void> => {
    return console.log("Сервисы на добавление:" + services);
};

const deleteServices = async (services: Array<string>): Promise<void> => {
    return console.log("Сервисы на удаление:" + services);
};




export const fakeUpdateService: IUpdateComponent = {
    getAddress,
    getServices,
    getInstallServices,
    getInstallPlugins,
    getPlugins,
    updateServices,
    deleteServices,
};